<template>
  <el-table :data="pileDataTable" stripe style="width: 100%" ref="pileDataTable" border
            v-loading="listLoading">
    <!--                <af-table-column type="selection" width="30"></af-table-column>-->
    <af-table-column prop="name" label="箱变名称"></af-table-column>
    <af-table-column prop="operatorName" label="运营商名称"></af-table-column>
    <af-table-column prop="stationName" label="场站名称"></af-table-column>
    <af-table-column prop="powerLoad" label="箱变负荷(KW)"></af-table-column>
    <af-table-column label="开放状态">
      <template slot-scope="{row}">
        <div v-if="row.isOpen">
          <el-tag :type="row.isOpen | availableFilter" >
            {{ row.isOpen | YesOrNoFilter }}
          </el-tag>
        </div>
      </template>
    </af-table-column>
    <af-table-column label="操作" width="240px">
      <template slot-scope="scope">
        <el-button size="mini" plain @click="showViewVisible(scope.$index, scope.row)">视图
        </el-button>
        <el-button size="mini" @click="pileEdit(scope.$index, scope.row)">编辑
        </el-button>
        <el-button size="mini" type="danger" @click="pileDelete(scope.$index, scope.row)">删除
        </el-button>
      </template>
    </af-table-column>
  </el-table>
</template>

<script>
  export default {
    name: "list",
    data(){
      return{

      }
    },
    props:{
      pileDataTable:{},
      listLoading:false,
    },
    filters: {
      availableFilter(code) {
        const map = {
          Y: 'success',
          N: 'danger'
        }
        return map[code]
      },
      YesOrNoFilter(code) {
        const map = {
          Y: '开启',
          N: '关闭',
        }
        return map[code]
      },
    },
    methods:{
      showViewVisible(index,row){
        this.$emit("showViewVisible",index,row)
      },
      pileEdit(index,row){
        this.$emit("pileEdit",index,row)
      },
      pileDelete(index,row){
        this.$emit("pileDelete",index,row)
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/module/resourceCenter/page/gunBox/list.vue